import { useLocation } from 'quartz-routing/react-router';
export const usePlaylistIdFromSearch = () => {
  const {
    search
  } = useLocation();
  const params = new URLSearchParams(search);
  const playlistIdSearchString = params.get('playlistId');
  if (playlistIdSearchString) return parseInt(playlistIdSearchString, 10);
  return undefined;
};